import { Nillable } from '@web/utils';
import { PublicBrandCosmeticSortType } from '../types/public-brand-cosmetic-sort-type';

export class PublicBrandCosmeticsQuery {
  public constructor(
    private readonly data: {
      sortType?: Nillable<PublicBrandCosmeticSortType>;
    },
  ) {}

  public get sortType(): Nillable<PublicBrandCosmeticSortType> {
    return this.data.sortType;
  }
}
